<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Node Utilization Report</h4>
    <i style="z-index: 1; justify-content: end;" class="bi bi-x-lg text-danger float-end" color="warn" (click)="onClose()" title="Close"></i>
  </div>
  <div id="html2Pdf" class="rightPanel">
    <div>
      <div class="actionBar">
        <select #dateFilter title="Select Time Range" name="dateFilter" id="" (change)="changeGranularityOptions($event.target.value)">
          <option value="1">Last 24hrs</option>
          <option value="7" selected>7 Days</option>
          <option value="30">30 Days</option>
          <option value="90">90 Days</option>
        </select>
        <select #granularityFilter title="Choose Granularity" name="granularity">
          <option *ngFor="let gran of availableGranularity" [value]="gran">{{ gran }}</option>
        </select>
        <button class="default-btn"
                (click)="
        applyFilters(
          '',
          dateFilter.value,
          granularityFilter.value,
          'all',
          'all'
        )
      ">
          Apply Filter
        </button>
        <!--<button class="default-btn ms-0"
                (click)="downloadAllCanvas()">
          Download Chart
        </button>-->
        <button class="default-btn ms-0"
                title="Download chart as PDF"
                (click)="generatePdf()">
          <span class="bi bi-file-earmark-pdf"></span>
          Export to PDF
        </button>
      </div>
    </div>
    <div>
      <div class="charts">
        <div style="height: 35vh; width:30vw;">
          <canvas baseChart
                  [data]="nodeUtilizationDataTotal"
                  [options]="nodeUtilizationOptionsTotal"
                  [type]="nodeUtilizationType"></canvas>
        </div>
        <div style="height: 35vh; width:30vw;">
          <canvas baseChart
                  [data]="nodeUtilizationDataOffice"
                  [options]="nodeUtilizationOptionsTotalOffice"
                  [type]="nodeUtilizationType"></canvas>
        </div>
        <div style="height: 35vh; width:30vw;">
          <canvas baseChart
                  [data]="nodeUtilizationDataNonOffice"
                  [options]="nodeUtilizationOptionsNonOffice"
                  [type]="nodeUtilizationType"></canvas>
        </div>
      </div>
      <ngx-spinner bdColor="rgba(0,0,0,0)"
                   size="default"
                   zIndex="1"
                   color="var(--s-primary-color)"
                   type="ball-spin"
                   [fullScreen]="false"
                   name="reports"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
    </div>
  </div>
</div>
